import { NgFor } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  Inject,
  Signal,
} from "@angular/core";
import { ChatOpenStore } from "app/chat";
import { APP_CONFIG, AppConfig, AppHostService } from "app/core";
import { IconButtonComponent } from "app/core/ui";
import { DragHandleComponent } from "../drag-handle-component";
import { HeaderLogoComponent } from "../logo-component";
import { HeaderAction } from "./header-action.model";
import { HeaderActionsService } from "./header-actions.service";

/** The header of the chat box. */
@Component({
  selector: "header[main]",
  templateUrl: "./template.html",
  styleUrls: ["./style.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, HeaderLogoComponent, DragHandleComponent, IconButtonComponent],
  providers: [HeaderActionsService],
})
export class HeaderComponent {
  @HostBinding("class") hostClasses = "rounded-top-5 d-flex align-items-center gap-3 p-3";

  protected readonly isDragDropEnabled = computed(() => {
    const isSmallScreen = this.appHostService.isSmallScreen();
    return !isSmallScreen && (this.config.isDragDropEnabled ?? false);
  });

  /** Styles to be applied to action buttons */
  protected buttonsStyles = {
    color: "var(--fof-header-button-color)",
    bgColor: "var(--fof-header-button-bg-color)",
    borderColor: "var(--fof-header-button-border-color)",
    colorOnHover: "var(--fof-header-button-hover-color)",
    bgColorOnHover: "var(--fof-header-button-hover-bg-color)",
    borderColorOnHover: "var(--fof-header-button-hover-border-color)",
  };
  protected actions: Signal<HeaderAction[]>;

  constructor(
    @Inject(APP_CONFIG) private readonly config: AppConfig,
    protected readonly chatOpenStore: ChatOpenStore,
    headerActionsService: HeaderActionsService,
    private readonly appHostService: AppHostService
  ) {
    this.actions = headerActionsService.actions;
  }
}
